/* eslint-disable import/prefer-default-export */
import { createAction, RSAA } from 'redux-api-middleware'
import queryString from 'query-string'
import { action as azureBlockUploadAction } from 'abu-redux-middleware'

import { HUBBLE_API_TOKEN } from '../store/middleware/APIUrl'
import { EstateUtils, ObjectUtils } from '../utils'
import { fetchConnectedDevices } from './socket'

export const Types = {
    EDIT_NOTE_REQUEST: 'EDIT_NOTE##REQUEST',
    EDIT_NOTE_SUCCESS: 'EDIT_NOTE##SUCCESS',
    DELETE_NOTE_REQUEST: 'DELETE_NOTE##REQUEST',
    DELETE_NOTE_SUCCESS: 'DELETE_NOTE##SUCCESS',
    FETCH_DEVICE_REQUEST: 'FETCH_DEVICE##REQUEST',
    FETCH_DEVICE_SUCCESS: 'FETCH_DEVICE##SUCCESS',
    FETCH_STORES_REQUEST: 'FETCH_STORES##REQUEST',
    FETCH_STORES_SUCCESS: 'FETCH_STORES##SUCCESS',
    UPDATE_STORE_REQUEST: 'UPDATE_STORE##REQUEST',
    UPDATE_STORE_SUCCESS: 'UPDATE_STORE##SUCCESS',
    CREATE_STORE_REQUEST: 'CREATE_STORE##REQUEST',
    CREATE_STORE_SUCCESS: 'CREATE_STORE##SUCCESS',
    FETCH_SINGLE_STORE_REQUEST: 'FETCH_SINGLE_STORE##REQUEST',
    FETCH_SINGLE_STORE_SUCCESS: 'FETCH_SINGLE_STORE##SUCCESS',
    STORE_NOTE_REQUEST: 'STORE_NOTE##REQUEST',
    STORE_NOTE_SUCCESS: 'STORE_NOTE##SUCCESS',
    STORE_NOTE_IMAGE_REQUEST: 'STORE_IMAGE_NOTE##REQUEST',
    STORE_NOTE_IMAGE_SUCCESS: 'STORE_IMAGE_NOTE##SUCCESS',
    STORE_NOTE_IMAGE_UPLOADED: 'STORE_IMAGE_NOTE##UPLOADED',
    DELETE_STORE_REQUEST: 'DELETE_STORE##REQUEST',
    DELETE_STORE_SUCCESS: 'DELETE_STORE#SUCCESS',
    CHANGE_STORE_FILTERS: 'CHANGE_STORE_FILTERS',
    CHANGE_STORE_SEARCH_STRING: 'CHANGE_STORE_SEARCH_STRING',
    API_CALL_FAILURE: 'API_CALL##FAILURE',
    CHANGE_DEVICES: 'CHANGE_DEVICES',
    DESELECT_STORE: 'DESELECT_STORE',
}

/**
 * @deprecated
 */
export const StoreTypes = Types

/**
 * @deprecated
 */
export const StoreActions = Types

export const StoresSearchModes = {
    searchByStore: { value: 'searchByStore', name: 'Store' },
    searchByDevice: { value: 'searchByDevice', name: 'Device' },
}

/**
 * Fetch stores information
 */
export function fetchStores(chainFilter) {
  return createAction({
    endpoint: `${HUBBLE_API_TOKEN}/stores?chainFilter=${chainFilter}`,
    method: 'GET',
    types: [
      Types.FETCH_STORES_REQUEST,
      {
        type: Types.FETCH_STORES_SUCCESS,
        meta: { pagination: false },
      },
      Types.API_CALL_FAILURE,
    ],
  });
};

/**
 * Fetch stores information with pagination
 * @param {Object} opts
 * @param {string} [opts.search] Search string
 * @param {unknown} [opts.order] Field to order by
 * @param {number} [opts.page] Request page
 * @param {'ASC'|'DESC'} [opts.orderType]
 * @param {1|0} [opts.paginated]
 * @param {string} [opts.mode] Search mode
 * @param {boolean} [opts.showEmptyStores]
 * @param {number[]} [opts.chainsToFilter]
 * @param {string[]} [opts.countriesToFilter]
 * @param {string[]} [opts.statusToFilter]
 * @param {string[]} [opts.selectedGroupsToFilter]
 */
export const fetchStoresPaginated = ({
  search = '',
  order = null,
  page = 0,
  migrated = true,
  mode = 'searchByStore',
  orderType = 'ASC',
  selectedGroupsToFilter = null,
  statusToFilter = null,
  countriesToFilter = null,
  chainsToFilter = null,
  paginated = 1,
  showEmptyStores = false,
}) => {
  let statusToFilterAsString = null;
  let groupsFilterAsString = null;
  let countriesToFilterAsString = null;
  let chainsToFilterAsString = null;
  if (selectedGroupsToFilter && selectedGroupsToFilter.length > 0)
    groupsFilterAsString = selectedGroupsToFilter.join();
  if (statusToFilter && statusToFilter.length > 0)
    [statusToFilterAsString] = statusToFilter;
  if (countriesToFilter && countriesToFilter.length > 0)
    countriesToFilterAsString = countriesToFilter.join();
  if (chainsToFilter && chainsToFilter.length > 0)
    chainsToFilterAsString = chainsToFilter.join();

  const toQueryString = {
    [mode]: search,
    countries: countriesToFilterAsString,
    chainFilter: chainsToFilterAsString,
    filterGroups: groupsFilterAsString,
    migrated: migrated ? '1' : '0',
    order,
    orderType,
    page,
    paginated,
    search,
    showEmptyStores: showEmptyStores ? '1' : null,
    status: statusToFilterAsString,
  };

    const query = queryString.stringify(toQueryString, {
        skipNull: true,
    })

    return createAction({
        endpoint: `${HUBBLE_API_TOKEN}/stores?${query}`,
        method: 'GET',
        types: [
            Types.FETCH_STORES_REQUEST,
            {
                type: Types.FETCH_STORES_SUCCESS,
                meta: { pagination: true, noFirstPage: page > 1 },
            },
            Types.API_CALL_FAILURE,
        ],
        options: {
            abortable: true,
        },
    })
}

/**
 * Fetch stores information with pagination and devices status
 * @param {Object} opts
 * @param {String} opts.name Store name to search by
 * @param {String} opts.order Field to order by
 * @param {String} opts.page Request page
 */
 export const fetchStoresPaginatedAndDevicesStatus = ({
    search,
    order,
    page,
    migrated,
    mode,
    orderType,
    selectedGroupsToFilter,
    statusToFilter,
    countriesToFilter,
    chainsToFilter,
    showEmptyStores,
  } = {}) => async dispatch => {
    const out = await dispatch(
      fetchStoresPaginated({
        search,
        order,
        page,
        migrated,
        mode,
        orderType,
        selectedGroupsToFilter,
        statusToFilter,
        countriesToFilter,
        chainsToFilter,
        showEmptyStores,
      })
    );

    dispatch(fetchConnectedDevices());

    return out;
  };

/**
 * Fetch stores information and devices online status
 */
export const fetchStoresAndDevicesStatus =
  (chainFilter) => async (dispatch) => {
    const out = await dispatch(fetchStores(chainFilter));

    dispatch(fetchConnectedDevices());

    return out;
  };

/**
 * Fetch stores information
 * @param {object} params
 * @param {string} params.storeCode store code
 * @param {number[]} [params.deviceGroups]
 * @param {('online'|'offline')[]} [params.connectionStatus]
 * @param {('migrated'|'not-migrated')[]} [params.migration]
 * @param {number[]} [params.chains]
 * @param {string} [params.deviceId]
 */
export function fetchSingleStore({
    storeCode,
    deviceGroups = null,
    connectionStatus = null,
    migration = null,
    chains = null,
    deviceId = null,
}) {
    const dg = deviceGroups?.join(',')
    const ch = chains?.join(',')
    const cs = connectionStatus?.map(v => {
        if (v === 'online') {
            return 1
        }

        if (v === 'offline') {
            return 0
        }

        return null
    }).filter(v => typeof v =='number' || !isNaN(v)).join(',')
    const mg = migration?.map(v => {
        if (v === 'migrated') {
            return 1
        }

        if (v === 'not-migrated') {
            return 0
        }

        return null
    }).filter(v => typeof v =='number' || !isNaN(v)).join(',')    

    const endpoint = queryString.stringifyUrl(
        {
            url: `${HUBBLE_API_TOKEN}/stores/${storeCode}`,
            query: { dg, cs, mg, ch, uid: deviceId },
        },
        {
            skipNull: true,
        }
    )

    return createAction({
        endpoint,
        method: 'GET',
        types: [Types.FETCH_SINGLE_STORE_REQUEST, Types.FETCH_SINGLE_STORE_SUCCESS, Types.API_CALL_FAILURE],
    })
}

/**
 * Create new store
 * @param store The store object
 */
export const createStore = (store) => {
    let body = store
    body = JSON.stringify(store)

    return (dispatch, getState) => {
        const state = getState()
        const api = EstateUtils.getAPI(state)
        return dispatch({
            [RSAA]: {
                endpoint: `${api}/stores`,
                method: 'POST',
                types: [Types.CREATE_STORE_REQUEST, Types.CREATE_STORE_SUCCESS, Types.API_CALL_FAILURE],
                body,
            },
        })
    }
}

/**
 * Delete store
 * @param storeCode The store code
 */
export const deleteStore = (storeCode, index) => {
    return (dispatch, getState) => {
        const state = getState()
        const api = EstateUtils.getAPI(state)
        return dispatch({
            [RSAA]: {
                endpoint: `${api}/stores/${storeCode}`,
                method: 'DELETE',
                types: [
                    Types.DELETE_STORE_REQUEST,
                    {
                        type: Types.DELETE_STORE_SUCCESS,
                        meta: { index },
                    },
                    Types.API_CALL_FAILURE,
                ],
            },
        })
    }
}

/**
 * Update store info
 * @param {object} data The store object
 * @param {string} storeCode The store code object
 * @param {number} [index] The store code object
 */
export const storeUpdate = (data, storeCode, index) => {
    const fieldsToSend = ['code', 'name', 'phone_primary', 'phone_secondary', 'email', 'slug', 'postcode', 'address', 'chan_id', 'country_code', 'lat']
    const store = ObjectUtils.copy(data, fieldsToSend)
    const body = JSON.stringify(store)

    return (dispatch, getState) => {
        const state = getState()
        const api = EstateUtils.getAPI(state)
        return dispatch({
            [RSAA]: {
                endpoint: `${api}/stores/${storeCode}`,
                method: 'PUT',
                types: [
                    Types.UPDATE_STORE_REQUEST,
                    {
                        type: Types.UPDATE_STORE_SUCCESS,
                        meta: { index },
                    },
                    Types.API_CALL_FAILURE,
                ],
                body,
            },
        })
    }
}

/**
 * Store and upload an image attached to a note
 * @param {Number} data.noteID
 * @param {File} data.image
 * @param {Number} data.parentID
 */
const storeNoteImage =
    ({ noteID, parentID, image }) =>
    async (dispatch) => {
        const body = JSON.stringify({
            store_note_id: noteID,
        })

        // Create new record
        const { type, payload: imageRecord } = await dispatch({
            [RSAA]: {
                endpoint: `${HUBBLE_API_TOKEN}/store_note_images`,
                method: 'POST',
                types: [StoreTypes.STORE_NOTE_IMAGE_REQUEST, StoreTypes.STORE_NOTE_IMAGE_SUCCESS, StoreTypes.API_CALL_FAILURE],
                body,
            },
        })

        // Check it's succesfully stored
        if (type !== StoreTypes.STORE_NOTE_IMAGE_SUCCESS) {
            throw new Error('Error when creating note image')
        }

        const { upload_url: urlToUpload } = imageRecord

        // Upload the image file
        await dispatch(azureBlockUploadAction(urlToUpload, image))

        await dispatch({
            type: StoreTypes.STORE_NOTE_IMAGE_UPLOADED,
            payload: imageRecord,
            meta: { noteID, parentID },
        })
    }

/**
 * Stores a new note for a certain store
 * @param {object} data
 * @param {string} data.storeCode store code
 * @param {string} data.note note
 * @param {string} [data.image]
 * @param {string} parentID
 */

export const storeNote = ({ storeCode, note, image }, parentID) => {
    return async (dispatch, getState) => {
        const state = getState()
        const { user: { session: { email } } } = state

        const body = JSON.stringify({
            store_code: storeCode,
            note,
            user_name: email,
            sticky: false,
            user_id: 0,
            parent_id: parentID,
        })

        const { type, payload: noteRecord } = await dispatch(
            createAction({
                endpoint: `${HUBBLE_API_TOKEN}/store_notes`,
                method: 'POST',
                types: [
                    Types.STORE_NOTE_REQUEST,
                    {
                        type: Types.STORE_NOTE_SUCCESS,
                        meta: { parentID },
                    },
                    Types.API_CALL_FAILURE,
                ],
                body,
            }),
        )

        if (type !== Types.STORE_NOTE_SUCCESS) {
            throw new Error('Error when creating note image')
        }

        const { id: noteID } = noteRecord

        if (image) {
            await dispatch(storeNoteImage({ noteID, parentID, image }))
        }
    }
}

/**
 * Edit a note
 * @param {Object} note note
 */
export const editNote = (note, index) => {
    // On develop
    const { EDIT_NOTE_REQUEST, EDIT_NOTE_SUCCESS, API_CALL_FAILURE } = StoreActions
    const body = JSON.stringify(note)

    return (dispatch, getState) => {
        const state = getState()
        const api = EstateUtils.getAPI(state)
        return dispatch({
            [RSAA]: {
                endpoint: `${api}/store_notes/${note.id}`,
                method: 'PUT',
                types: [
                    EDIT_NOTE_REQUEST,
                    {
                        type: EDIT_NOTE_SUCCESS,
                        meta: { index },
                    },
                    API_CALL_FAILURE,
                ],
                body,
            },
        })
    }
}

/**
 * Edit a note
 * @param {Integer} id Note id
 * @param {Integer} parentID Parent Note id
 */
export const deleteNote = (id, parentID) => {
    return (dispatch, getState) => {
        const state = getState()
        const api = EstateUtils.getAPI(state)
        return dispatch({
            [RSAA]: {
                endpoint: `${api}/store_notes/${id}`,
                method: 'DELETE',
                types: [
                    StoreTypes.DELETE_NOTE_REQUEST,
                    {
                        type: StoreTypes.DELETE_NOTE_SUCCESS,
                        meta: { id, parentID },
                    },
                    StoreTypes.API_CALL_FAILURE,
                ],
            },
        })
    }
}

export const deviceConnectedSocket = (id, withNotification = false) => ({
    type: 'DEVICE_CONNECTION_SOCKET',
    payload: { id },
    meta: { withNotification },
})

export const deviceConnectedSocketArray = (ids, withNotification = false) => ({
    type: 'DEVICE_CONNECTION_SOCKET_ARRAY',
    payload: { ids },
    meta: { withNotification },
})

export const deviceDisconnectedSocket = (id, withNotification = false) => ({
    type: 'DEVICE_DISCONNECTION_SOCKET',
    payload: { id },
    meta: { withNotification },
})

export const screenshotReceived = (id, screenshot) => ({
    type: 'SCREENSHOT_RECEIVED',
    payload: { id, screenshot, date: new Date().getTime() },
})

export const screenshotRemove = (id) => ({
    type: 'SCREENSHOT_REMOVE',
    payload: { id },
})

export const downloadPercentage = (id, percentage) => ({
    type: 'DOWNLOAD_PERCENTAGE',
    payload: { id, percentage },
})

export const clearSelectedStore = () => ({
    type: 'CLEAR_SELETED_STORE',
})

export const fetchDevice = (deviceID) => {
    return (dispatch, getState) => {
        const state = getState()
        const api = EstateUtils.getAPI(state)
        return dispatch({
            [RSAA]: {
                endpoint: `${api}/devices/${deviceID}`,
                method: 'GET',
                types: [Types.FETCH_DEVICE_REQUEST, Types.FETCH_DEVICE_SUCCESS, Types.API_CALL_FAILURE],
            },
        })
    }
}

export const changeStoreFilters = (filters) => ({
    type: Types.CHANGE_STORE_FILTERS,
    payload: { filters },
})

export const changeStoreSearchString = (search) => ({
    type: Types.CHANGE_STORE_SEARCH_STRING,
    payload: { search },
})

export const changeDevicesArray = (devices) => ({
    type: Types.CHANGE_DEVICES,
    payload: devices,
})

export const deselectStore = () => ({
    type: Types.DESELECT_STORE,
})
 